import { useMutation } from "@apollo/client";
import { Article, UpdateArticleInput } from "../../../api/schema";
import { FlexBox, FlexBoxInline } from "../../../components/flex/Flex";
import {
  InputFormBuilder,
  InputFormBuilderState,
} from "../../../components/form/InputFormBuilder";
import {
  InputFormMode,
  ValuesVariables,
} from "../../../components/form/InputForm";
import { UserLanguage } from "../../../lang/lang";
import {
  ArticleViewResponse,
  UpdateArticleMutation,
  UpdateArticleResponse,
} from "../helper/graphql";
import { ArticleSourcesList } from "./ArticleSourcesList";
import { ArticleParameterSettings } from "./Parameter/ArticleParameter";
import { ArticlePriceInformation } from "./Price/ArticlePriceSettings";
import { UpdateModalKeys } from "./UpdateModal";

export const ArticleView = (props: {
  article_view: ArticleViewResponse;
  refetch: () => void;
}) => {
  const keys = UpdateModalKeys(props.article_view);

  const [updatePart] = useMutation<
    UpdateArticleResponse,
    ValuesVariables<UpdateArticleInput>
  >(UpdateArticleMutation);

  return (
    <div className="article_view">
      <FlexBox className="article_view_settings">
        <h3>{UserLanguage().pages.article.view}</h3>
        <InputFormBuilder<Article>
          input={props.article_view.article}
          mode={InputFormMode.Edit}
          onSuccess={props.refetch}
          reformId={[
            "footprint",
            "location",
            "article_category",
            "product_group",
          ]}
          mutation={updatePart}
          keys={keys}
          texts={UserLanguage().pages.article.actions}
        >
          {(builder: InputFormBuilderState<Article>) => (
            <div>
              {builder.buildCards()}
              <FlexBoxInline
                style={{ gap: 15, justifyContent: "space-between" }}
              >
                {builder.buildField("matchcode")}
                {builder.buildField("display_name")}
              </FlexBoxInline>
              {builder.buildField("name")}
              {builder.buildField("footprint")}
              <FlexBoxInline
                style={{ gap: 15, justifyContent: "space-between" }}
              >
                {builder.buildField("article_category")}
                {builder.buildField("product_group")}
              </FlexBoxInline>
              <FlexBoxInline
                style={{ gap: 15, justifyContent: "space-between" }}
              >
                {builder.buildField("location")}
                {builder.buildField("inventory_type")}
              </FlexBoxInline>
              {builder.buildField("fields")}
              {builder.buildField("datasheet_url")}
              {builder.buildField("picture")}
              {builder.buildField("description")}
              {builder.buildSubmitButton()}
            </div>
          )}
        </InputFormBuilder>
      </FlexBox>
      <div style={{ flexGrow: 10 }}>
        <ArticleParameterSettings
          article={props.article_view.article}
          on_changed={props.refetch}
        />
        <ArticlePriceInformation
          article={props.article_view.article}
          on_created={props.refetch}
        />
      </div>
      <FlexBox>
        <ArticleSourcesList data={props.article_view} refetch={props.refetch} />
      </FlexBox>
    </div>
  );
};
